import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import Layout from './Layout'
import Form from './Form'
import { emptyGroup } from './GroupCard'
import { extractErrorMessage } from '../../utils/extractErrorMessage'
import { usePostLuckyDraw } from '../../api/lucky-draw'

const blankValues = {
  name: '',
  source: '',
  maxWinsPerDraw: 2,
  groups: [emptyGroup],
}

// Nothing to fetch and nothing to tab between — entries only exist once the draw does.
export const LuckyDrawCreatePage = () => {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { mutateAsync: create, isLoading } = usePostLuckyDraw()

  const onSubmit = async (payload) => {
    try {
      await create(payload)
      enqueueSnackbar('Successfully created', { variant: 'success' })
      navigate('/lucky-draw')
    } catch (e) {
      enqueueSnackbar(extractErrorMessage(e), { variant: 'error' })
    }
  }

  return (
    <Layout title='Create Lucky Draw'>
      <Form
        defaultValues={blankValues}
        onSubmit={onSubmit}
        isSaving={isLoading}
        submitLabel='CREATE'
      />
    </Layout>
  )
}
